import type { AppointmentResponse } from '@dataTypes/appointment.type'
import { getTodayScheduleAppointments } from '@services/api/dashboard/overview.api'
import { useAppSelector } from '@store/hooks'
import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'

/** Today's schedule is always day-scoped (ignores Overview 1D–YTD range). */
export function useTodayScheduleAppointments(
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<AppointmentResponse[]> {
  const refreshKey = useAppSelector((state) => state.patient.refresh)
  const queryParams = useDashboardPeriodParams('1D', date)
  return useDashboardPeriodFetch(queryParams, getTodayScheduleAppointments, {
    refreshKey,
    enabled,
    queued,
    cacheKey: 'getTodayScheduleAppointments',
  })
}
